import {
  UPLOADER_STATUS_COMPLETED,
  UPLOADER_STATUS_COMPLETING,
  type UploaderState,
} from '../state';

/**
 * Whether a stored upload that no uploader is running for has to be cancelled
 * to undo what it did in Iconik. Chunks only exist once an uploader has been
 * made for it, so an upload without them created nothing: queue() and cancel()
 * both leave it that way. One being completed is left to finish, since its file
 * is already uploaded.
 */
export const needsCancelling = (state: UploaderState): boolean => {
  if (
    state.status === UPLOADER_STATUS_COMPLETED ||
    state.status === UPLOADER_STATUS_COMPLETING
  ) {
    return false;
  }
  return state.chunks !== undefined;
};
